"use client";

// Prix de revente conseille, pour les comptes pro seulement (users.isPro = true) :
// fiche produit, panier et paiement (GT-261007-HVGQ). `amountEUR` : le prix d'achat TTC
// (remise du compte deduite). `format` : formateur de l'ecran s'il en a un (montant EUR ->
// texte dans la devise affichee) ; sinon ConvertedPrice.
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "@/app/lib/hooks";
import ConvertedPrice from "@/app/[lang]/[currency]/(chrome)/checkout/ConvertedPrice";
import { resaleRange } from "@/app/lib/resale";

interface Props {
  amountEUR: number;
  format?: (eur: number) => string;
  style?: React.CSSProperties;
}

const ResaleHint: FC<Props> = ({ amountEUR, format, style }) => {
  const { t } = useTranslation("guydeez");
  const isPro = useAppSelector((s: any) => s.auth?.user?.isPro === true);
  if (!isPro || !(Number(amountEUR) > 0)) return null;
  const [min, max] = resaleRange(Number(amountEUR));
  const money = (v: number) =>
    format ? <span>{format(v)}</span> : <span style={{ display: "inline-flex" }}><ConvertedPrice price={v} /></span>;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "baseline",
        flexWrap: "wrap",
        gap: "2px 6px",
        padding: "8px 12px",
        borderRadius: 10,
        background: "#F3FAF5",
        border: "1px solid var(--g-green-soft, #CDEBD6)",
        fontSize: 13,
        color: "var(--g-ink-700, #374151)",
        ...style,
      }}
    >
      <span style={{ fontWeight: 600 }}>{t("resale_hint_label", { defaultValue: "Revente conseillée :" })}</span>
      <span style={{ display: "inline-flex", alignItems: "baseline", gap: 4, fontWeight: 800, color: "var(--g-green-ink, #1F7A45)" }}>
        {money(min)} – {money(max)}
      </span>
      <span style={{ flexBasis: "100%", fontSize: 11, color: "var(--g-ink-500)" }}>
        {t("resale_hint_basis", { defaultValue: "+45 % à +70 % sur votre prix d’achat TTC" })}
      </span>
    </div>
  );
};

export default ResaleHint;
